export function getVisibleOptions<T>(options: T[], maxVisibleItems: number | null, showAll: boolean): T[] {
  const hasNoCollapsedItems: boolean =
    maxVisibleItems === null || maxVisibleItems < 0 || maxVisibleItems >= options.length;

  return showAll || hasNoCollapsedItems ? options : options.slice(0, maxVisibleItems ?? 0);
}
